/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Action_Deactivateall3Inputs */

const en_settings_reportingapikeys_action_deactivateall3 = /** @type {(inputs: Settings_Reportingapikeys_Action_Deactivateall3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deactivate all keys for this user`)
};

/**
* | output |
* | --- |
* | "Deactivate all keys for this user" |
*
* @param {Settings_Reportingapikeys_Action_Deactivateall3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_action_deactivateall3 = /** @type {((inputs?: Settings_Reportingapikeys_Action_Deactivateall3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Action_Deactivateall3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_action_deactivateall3(inputs)
});
export { settings_reportingapikeys_action_deactivateall3 as "settings_reportingApiKeys_action_deactivateAll" }